import React, { ReactNode } from 'react';

import { ITab } from '../../../types/shared';

import ToggleTabs from '../../atoms/toggle-tabs/ToggleTabs';

interface Props {
  activeTab?: ITab;
  tabs: ITab[];
  onTabChange: (tab: ITab) => void;
  children?: ReactNode;
}

const TabWrapperGeneric = ({
  tabs,
  activeTab,
  onTabChange,
  children,
}: Props) => (
  <div>
    {tabs.length > 1 && (
      <ToggleTabs
        selectedTab={activeTab}
        totalTabs={tabs}
        onTabClick={(tab) => onTabChange(tab)}
      />
    )}
    <div>{children}</div>
  </div>
);

export default TabWrapperGeneric;
